import { differenceInDays } from 'date-fns';

import { SearchData } from '@shared/base-search-bar/entities/search-data';

export function getExchangeWithAssistanceAndLongerDuration(
  withAssistance: boolean, originalDepartureDate: string, originalArrivalDate: string, search: SearchData
): boolean {
  const originalDays = originalArrivalDate ?
    differenceInDays(new Date(originalArrivalDate), new Date(originalDepartureDate)) : 1;
  const currentDays = originalArrivalDate ? differenceInDays(search.arrivalDate, search.departureDate) : 1;
  return currentDays > originalDays && !!withAssistance;
}

export function getExchangeWithAssistanceAndShorterOrEqualDuration(
  withAssistance: boolean, originalDepartureDate: string, originalArrivalDate: string, search: SearchData
): boolean {
  const originalDays = originalArrivalDate ?
    differenceInDays(new Date(originalArrivalDate), new Date(originalDepartureDate)) : 1;
  const currentDays = originalArrivalDate ? differenceInDays(search.arrivalDate, search.departureDate) : 1;
  return currentDays <= originalDays && !!withAssistance;
}
